//封装了一个exportDocx方法
// 注意：file-saver 依赖 Blob 对象
import { saveAs } from 'file-saver'
// htmlDocx 的作用就是将html字符串转成Blob对象
import htmlDocx from 'html-docx-js/dist/html-docx'

// 测试函数
export const exportDocxTest = (domString, fileName) => {
  var converted = htmlDocx.asBlob(domString)
  // var blob = new Blob(['Hello, world!'], { type: 'text/plain;charset=utf-8' })
  // saveAs(blob, 'test.docx')
  saveAs(converted, fileName + '.docx')
}

/**
 * 1.导出局部的html页面
 * @param {} dom 局部的html页面
 * @param {*} fileName 导出文件的名称
 * @param {*} title
 */
export const exportDocx = (dom, fileName, config, { title = document.title, width } = {}) => {
  if (!dom) return
  config = config || {}
  let copyDom = document.createElement('span')
  // const styleDom = document.querySelectorAll('style, link, meta')
  const titleDom = document.createElement('title')
  titleDom.innerText = title

  copyDom.appendChild(titleDom)
  // Array.from(styleDom).forEach(item => {
  //   copyDom.appendChild(item.cloneNode(true))
  // })
  const cloneDom = dom.cloneNode(true)
  if (width) {
    const domTables = cloneDom.getElementsByTagName('table')
    if (domTables.length) {
      for (const table of domTables) {
        table.style.width = width + 'px'
      }
    }
  }
  copyDom.appendChild(cloneDom)

  const htmlTemp = copyDom.innerHTML
  copyDom = null
  // console.log('htmlTemp=', htmlTemp)
  const iframeDom = document.createElement('iframe')
  const attrObj = {
    height: 0,
    width: 0,
    border: 0,
    wmode: 'Opaque'
  }
  const styleObj = {
    position: 'absolute',
    top: '-999px',
    left: '-999px'
  }
  Object.entries(attrObj).forEach(([key, value]) => {
    iframeDom.setAttribute(key, value)
  })
  Object.entries(styleObj).forEach(([key, value]) => {
    iframeDom.style[key] = value
  })
  document.body.insertBefore(iframeDom, document.body.children[0])
  const iframeWin = iframeDom.contentWindow // 1.获取iframe中的window
  const iframeDocs = iframeWin.document // 2.获取iframe中的document
  iframeDocs.write(`<!doctype html>`)
  iframeDocs.write(htmlTemp)

  const htmlDoc = `
  <!DOCTYPE html>
  <html lang="en">
  ${iframeDocs.documentElement.innerHTML}
  </html>
  `
  var converted = htmlDocx.asBlob(htmlDoc, config)
  saveAs(converted, fileName + '.docx')
  document.body.removeChild(iframeDom)
}
export default {
	exportDocx
}